import React from 'react';
import { ThemeProvider } from 'styled-components/macro';
import commonTheme from './common';
import {
  createMuiTheme,
  ThemeProvider as MThemeProvider,
} from '@material-ui/core/styles';

const mTheme = createMuiTheme({
  palette: {
    action: {
      disabled: '#BDBDBD',
    },
    primary: {
      main: '#b73f83',
      // '#c62f85'
    },
    secondary: {
      main: '#b73f83',
    },
    background: {
      default: '#f3f3f3',
    },
  },
  typography: {
    body1: {
      fontSize: '0.8rem',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'unset',
      },
    },
  },
  props: {
    // Name of the component ⚛️
    MuiButtonBase: {
      // The default props to change
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
  },
});
interface ThemeProps {}

export const DEFAULT_BREAKPOINT = 620;

const ThemeContextProvider: React.SFC<ThemeProps> = ({
  children,
}) => {
  return (
    <MThemeProvider theme={mTheme}>
      <ThemeProvider theme={commonTheme}>{children}</ThemeProvider>
    </MThemeProvider>
  );
};

export default ThemeContextProvider;
